<template>
    <div class="tw-cell-edit">
        <component :is="componentName" :key="componentName" v-model="text" :data_source="data_source" :caption_name="caption_name" :value_name="value_name" :readonly="readonly || disAllowEdit" @onQuery="onQuery" v-if="!params.params?.binding || (params.params?.binding && Object.keys(params.data).length)" style="width: -webkit-fill-available;">
        
        </component>

        <!-- 扩展按钮 -->
        <span class="p-buttonset tw-buttonset">
            <Button class="p-button-sm" v-for="item in buttons" :key="item.event_no" :label="item.button_caption" :icon="item.button_icon" v-show="item.enabled && (((readonly || disAllowEdit) && item.visible_browsing) || (!readonly && !disAllowEdit && item.visible_editing))" @click="btnClick(item.event_no)" />
        </span>
    </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import messageService from '../../services/message.service'
import Button from 'primevue/button';

export default {
    name: 'tw-cell-edit-ag',
    components: {
        Button
    },
    setup(props, context) {
        // console.log(props.params)
        const value = ref(props.params.value);

        /* Component Editor Lifecycle methods */
        // the final value to send to the grid, on completion of editing
        const getValue = () => {
            return value.value;
        };

        // Gets called once before editing starts, to give editor a chance to
        // cancel the editing before it even starts.
        const isCancelBeforeStart = () => {
            return false;
        };

        const onCellValueChanged = (e) => {
            console.log(e)
        }

        // Gets called once when editing is finished (eg if Enter is pressed).
        // If you return true, then the result of the edit will be ignored.
        // const isCancelAfterEnd = () => {
        //     // our editor will reject any value greater than 1000
        //     return value.value > 1000;
        // };

        const readonly = computed(() => {
            return props?.params?.readonly ?? false;
        });

        const text = computed({
            get() {
                if(props.params.data && props.params.colDef){
                    if(props.params?.binding && props.params.colDef.control_type !== "tw-input"){
                        return data_source.value?.datas.find(el => el[props.params?.binding.display_field] === value.value) ?? null
                    }else{
                        return value.value
                    }
                }else{
                    return null
                }
            },

            set(val){
                if(props.params.data && props.params.colDef){
                    if(props.params?.binding && props.params.colDef.control_type !== "tw-input"){
                        const select_row = data_source.value?.datas.find(el => el === val)

                        if(select_row){
                            props.params?.binding.setValues(props.params.data, select_row)
                            value.value = props.params.data[props.params.colDef.field_name]
                        }else{
                            messageService.warn('请设置好数据源显示字段')
                        }
                    }else if(props.params?.binding && props.params.colDef.control_type === "tw-input") {
                        const select_row = data_source.value?.datas.find(el => el[props.params.colDef?.field_name] === val)

                        if(select_row){
                            props.params?.binding.setValues(props.params.data, select_row)
                        }
                    }else{
                        value.value = val

                        // eslint-disable-next-line vue/no-mutating-props
                        props.params.data[props.params.colDef.field_name] = value
                    }
                }
            }
        })
        
        const componentName = computed(() => {
            const controlType = props.params.colDef && props.params.colDef.control_type
            // switch (controlType) {
            //     case 'datepicker':
            //         return 'tw-date-picker';
            //     case 'checkbox':
            //         return 'tw-checkbox'
            //     case 'dropdown':
            //         return 'tw-dropdown';
            //     case 'combobox':
            //         return 'tw-dropdown';
            //     case 'text':
            //         return 'tw-input';
            //     default:
            //         return 'tw-input';
            // }
            // 改为直接使用控件类型（类型即为组件名）
            return controlType ?? 'tw-input'
        })

        const disAllowEdit = computed(() => {
            const allowEdit = (props.params.colDef && props.params.colDef.allow_edit) ?? true;
            return !allowEdit
        })

        const buttons = computed(() => {
            return props?.params?.colDef?.buttons ?? []
        })

        const caption_name = ref();
        const value_name = ref();
        const data_source = ref();

        onMounted(async () => {
            if(props.params?.binding){
                caption_name.value = props.params?.binding.display_field
                // value_name.value = props.params?.binding.value_field
                value_name.value = ''   // 使得下拉组件的值为对象
                data_source.value = await props.params?.binding.getDataSource(props.params.data, {})
            }
        })

        // 【tw-input】查询
        const onQuery = async (keyword) => {
            data_source.value = await props.params?.binding.getDataSource(props.params.data, { keyword: keyword })
        }

        // 拓展按钮
        const btnClick = (event_no) => {
            context.emit('btnClick', { event_no })
        }

        return {
            componentName,
            disAllowEdit,
            text,
            data_source,
            caption_name,
            value_name,
            onQuery,
            buttons,
            btnClick,
            value,
            getValue,
            isCancelBeforeStart,
            // isCancelAfterEnd,
            onCellValueChanged,
            readonly
        }
    },
    props: ['params']
}
</script>

<style>

</style>